import React from 'react';
import { DAY_NAMES_PL } from '../utils/constants';

const CalendarDayHeader = ({
  day,
  showCheckbox = false,
  checked = false,
  onCheckChange,
  className = '',
}) => {
  const dayNameIndex = day.isoWeekday - 1;
  const dayName = DAY_NAMES_PL[dayNameIndex];

  return (
    <div
      className={`calendar-day__header ${day.isToday ? 'calendar-day__header--today' : ''} ${className}`}
    >
      {showCheckbox && (
        <input
          type="checkbox"
          className="calendar-day__checkbox"
          checked={checked}
          onChange={(e) => onCheckChange?.(e.target.checked, day)}
          aria-label={`Wybierz ${dayName}`}
        />
      )}

      <span className="calendar-day__name">{dayName}</span>
      <span className="calendar-day__date">{day.dayNumber}</span>
    </div>
  );
};

export default CalendarDayHeader;
